// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__1OUSM","infoBtn":"quickbooks_infoBtn__14okx","formBox":"quickbooks_formBox__1kgeV","formFooter":"quickbooks_formFooter__3S3Pn"};